import { action as apiAction } from 'api/Api'
import {
  setCardRelation
} from 'store/redux/cardRelations'
import { optimisticDispatch } from 'utils/sagas'

type Payload = {
  cardId: number
  defaultParentId: number
}

const requestChangeCardDefaultParent = (payload: Payload) => async dispatch => {
  const { cardId, defaultParentId } = payload

  const optimisticAction = optimisticDispatch(dispatch, setCardRelation({
    id: cardId,
    defaultParentId,
  }))

  try {
    await apiAction('ChangeDefaultCardParent', {
      cardId,
      defaultParentId,
    })

    optimisticAction.commit()
  } catch (error) {
    optimisticAction.revert()

    throw error
  }
}

export default requestChangeCardDefaultParent
